import React from "react";

const Loader = () => {
    const loaderStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "30vh",
        backgroundColor: "#FFFFFF",
    };

    const logoStyle = {
        width: "250px",
        animation: "pulse 2s infinite ease-in-out",
    };

    const spinnerContainerStyle = {
        position: "relative",
        width: "50px",
        height: "50px",
        marginLeft: "15px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    };

    const keyframes = `
    @keyframes spin1 {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    @keyframes spin2 {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(-360deg); }
    }
  `;

    return (
        <div style={loaderStyle}>
            <style>{keyframes}</style>
            <div style={{ display: "flex", alignItems: "center" }}>
                <img src="https://virtalibry.com/logo/Virtalibry_logo_sub_no_bg.png" alt="Virtalibry Logo" style={logoStyle} />
                <div style={spinnerContainerStyle}>
                    <div
                        style={{
                            width: "50px",
                            height: "50px",
                            border: "4px solid rgba(31, 111, 50, 0.3)",
                            borderTop: "4px solid #1f6f32",
                            borderRadius: "50%",
                            animation: "spin1 1s linear infinite",
                            position: "absolute",
                        }}
                    ></div>
                    <div
                        style={{
                            width: "40px",
                            height: "40px",
                            border: "4px solid rgba(76, 175, 80, 0.3)",
                            borderTop: "4px solid #4caf50",
                            borderRadius: "50%",
                            animation: "spin2 1.5s linear infinite",
                            position: "absolute",
                        }}
                    ></div>
                </div>
            </div>
        </div>
    );
};

export default Loader;
